import * as React from 'react';
import { Alert } from 'reactstrap';

import './ConfigurationAlerts.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Configuration3dAlert.messages';

export interface Configuration3dAlertState {
  visible: boolean;
}

export default class Configuration3dAlert extends React.Component<{}, Configuration3dAlertState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      visible: true
    };

    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    this.setState({ visible: false });
  }

  public render() {
    return (
      <div className="configuration-3d-alert">
        <Alert color="dark" isOpen={this.state.visible} toggle={this.onDismiss}>
          <h4><FormattedMessage {...MESSAGES.configuration3dAlertAttention} /></h4>
          <p><FormattedMessage {...MESSAGES.configuration3dAlertMessage} /></p>
        </Alert>
      </div>
    );
  }
}
